module.exports = __webpack_public_path__ + "img/20220225150914155ok7.42386e12.png";